import { useEffect, useState } from "react";
import { axiosGetWithHeader, ShowAlertError } from "../Common/axios";
import { AppHeader } from "./AppHeader";
import { useLocation } from "react-router-dom";
import Spinner from 'react-bootstrap/Spinner';
import { AppFooter } from "./AppFooter";

import { AstrologerInfoFooter } from "../Common/AstrologerInfoFooter";
import { OptionsTheoryMenu } from "./OptionsTheoryMenu";
import { OptionsTab } from "./Basic/OptionsTab";

export function OptionsTheory()  {
  const {state} = useLocation();
  const runningId = state?state.runningId:null;
  const [refreshKey, setRefreshKey] = useState(1);
  const [userData, setUserData] = useState(null);
  const [menuArray, setMenuArray] = useState([]);
  const [spinner, setSpinner] = useState('Loading - Rashi Chart Page');
  const [errorAlert, setErrorAlert] = useState(null);
  const handleMenu = (menuArray)=>setMenuArray(menuArray);

  useEffect(() => {
    axiosGetWithHeader("/userrequest/"+runningId,
      (response)=>{
        setUserData(response.data);
        setSpinner(null);
      },
      (error)=>{
        setUserData(null);
        setSpinner(null);
        console.log(error);
        setErrorAlert(error.message);
      }
    );
    setRefreshKey(refreshKey);
  }, [runningId,refreshKey]);

  return (
    <>
    <div class="m-0 p-0 row sticky-top bg-white noprint">
      <div class="m-0 p-0 col-12">
        <AppHeader/>
        <OptionsTheoryMenu userData={userData} handleMenu={handleMenu} />
      </div>    
    </div> 
    {spinner===null?<></>:<div class="text-center text-primary h5 pt-5">{spinner} <Spinner animation="border" size="sm" /></div>}
    { userData===null || userData===undefined || userData.length===0?<div class="menupageheight"></div>:
    <>
      <div class="m-0 p-0 row align-items-top content">
        <div class="m-0 p-0 col-12">
          <div class="menupageheight">
            <OptionsTab menuArray={menuArray}/>
          </div>  
        </div>
      </div>
    </>}
    <div class="m-0 p-0 row noprint">
      <div class="m-0 p-0 col-12">
        <AppFooter/>
      </div>    
    </div>
    <div class="m-0 p-0 row d-none d-print-block printfooter">
      <div class="m-0 p-0 col-12">
        <AstrologerInfoFooter userData={userData}  />
      </div>    
    </div> 
    <ShowAlertError errorAlert={errorAlert} setErrorAlert={setErrorAlert}/>
    </>
  );
}
